@if (modalData?.leadMagnet) {
    <div
        class="background flex min-w-full flex-col items-center justify-center px-4 pb-60 text-white md:min-w-screen-md md:px-16 md:pb-24">
        @if (!error) {
            <div class="max-w-sm">
                <h2>{{ modalData.leadMagnet.title }}</h2>
                <span>{{ modalData.leadMagnet.description }}</span>
                <form [formGroup]="leadMagnetForm" class="light">
                    <div class="form-element">
                        <label for="firstName" class="hidden">
                            First Name
                        </label>
                        <input
                            class="px-4 py-2"
                            id="firstName"
                            name="firstName"
                            formControlName="firstName"
                            type="text"
                            placeholder="First Name"
                            data-testid="leadMagnetModalFirstName" />
                    </div>
                    <div class="form-element">
                        <label for="email" class="hidden">
                            Email address
                        </label>
                        <input
                            class="px-4 py-2"
                            id="email"
                            name="email"
                            formControlName="email"
                            type="text"
                            placeholder="Email"
                            data-testid="leadMagnetModalEmail" />
                    </div>
                    <div class="form-element">
                        <app-save-button
                            [showLoader]="showLoader"
                            [success]="success"
                            [disabled]="
                                !(leadMagnetForm.valid && leadMagnetForm.dirty)
                            "
                            (onClick)="onSubmit()"
                            [additionalClasses]="[
                                'disabled:bg-red disabled:shadow-none',
                                'w-auto py-2 px-4 shadow-md',
                            ]"
                            data-testid="leadMagnetModalSubmit">
                            {{ modalData.leadMagnet.callToAction }}
                        </app-save-button>
                    </div>
                </form>
            </div>
        }
        @if (error) {
            <div class="max-w-md pb-16">
                <h2>There was an error 😢</h2>
                <p class="pb-2">
                    There was an error processing your request. Please try again
                    at a later time.
                </p>
                <p>
                    If it is an urgent request, feel free to reach out to
                    <a href="mailto:travel@followalice.com">
                        travel&#64;followalice.com </a
                    >.
                </p>
            </div>
        }
    </div>
}
